import { Brand } from "../../../types";
import { BrandManagementState } from "../types/brands-types";

/**
 * Validates brand form data
 */
export const validateBrandData = (data: Partial<Brand>): string | null => {
  if (!data.name || data.name.trim().length === 0) {
    return "Название бренда обязательно для заполнения";
  }

  if (data.name.trim().length < 2) {
    return "Название бренда должно содержать минимум 2 символа";
  }

  if (data.name.trim().length > 100) {
    return "Название бренда не должно превышать 100 символов";
  }

  return null;
};

/**
 * Formats brand data for API submission
 */
export const formatBrandData = (data: Partial<Brand>): Partial<Brand> => {
  return {
    name: data.name?.trim() || "",
  };
};

/**
 * Resets brand management state
 */
export const resetBrandState = (): BrandManagementState => ({
  isDrawerOpen: false,
  isDeleteModalOpen: false,
  editingBrand: null,
  deletingBrand: null,
});

/**
 * Opens edit drawer with brand data
 */
export const openEditDrawer = (brand: Brand): BrandManagementState => ({
  editingBrand: brand,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingBrand: null,
});

/**
 * Opens create drawer
 */
export const openCreateDrawer = (): BrandManagementState => ({
  editingBrand: null,
  isDrawerOpen: true,
  isDeleteModalOpen: false,
  deletingBrand: null,
});

/**
 * Closes drawer and resets editing state
 */
export const closeDrawer = (): BrandManagementState => ({
  isDrawerOpen: false,
  editingBrand: null,
  isDeleteModalOpen: false,
  deletingBrand: null,
});

/**
 * Opens delete modal with brand data
 */
export const openDeleteModal = (brand: Brand): BrandManagementState => ({
  deletingBrand: brand,
  isDeleteModalOpen: true,
  isDrawerOpen: false,
  editingBrand: null,
});

/**
 * Closes delete modal and resets deleting state
 */
export const closeDeleteModal = (): BrandManagementState => ({
  isDeleteModalOpen: false,
  deletingBrand: null,
  isDrawerOpen: false,
  editingBrand: null,
});

/**
 * Gets drawer title based on editing state
 */
export const getDrawerTitle = (editingBrand: Brand | null): string => {
  return editingBrand ? "Редактировать бренд" : "Создать бренд";
};

/**
 * Gets submit button text based on loading and editing state
 */
export const getSubmitButtonText = (
  isLoading: boolean,
  editingBrand: Brand | null
): string => {
  if (isLoading) return "Загрузка...";
  return editingBrand ? "Сохранить изменения" : "Добавить бренд";
};
